<script>
import { useHead } from '@unhead/vue';

// Renders a page's meta data.
export default {
  name: 'PageMetadata',
  render() {
    // Return null since this is only rendering meta data
    return null;
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    },
    canonicalUrl: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    var indexVal = 'noindex';
    var followVal = 'nofollow';
    var indexValue = '';

    if (props.route.fields?.robotsIndex?.value) {
      indexVal = 'index';
    }
    if (props.route.fields?.robotsFollow?.value) {
      followVal = 'follow';
    }

    indexValue = indexVal + ', ' + followVal;

    if (props.route.fields?.robotsMaxImagePreview?.value) {
      indexValue += ', ' + props.route.fields?.robotsMaxImagePreview?.value;
    }
    if (props.route.fields?.robotsMaxSnippet?.value) {
      indexValue += ', ' + props.route.fields?.robotsMaxSnippet?.value;
    }
    if (props.route.fields?.robotsMaxVideoPreview?.value) {
      indexValue += ', ' + props.route.fields?.robotsMaxVideoPreview?.value;
    }

    //todo; Does deduping work? https://unhead.unjs.io/usage/guides/handling-duplicates
    useHead({
      htmlAttrs: {
        lang: 'en'
      },
      title: props.route.fields?.pageTitle?.value?.trim() || 'Page',
      link: [
        {
          rel: 'canonical',
          href: props.canonicalUrl || ''
        }
      ],
      meta: [
        {
          name: 'description',
          content: props.route.fields?.pageDescription?.value?.trim() || ''
        },
        {
          name: 'robots',
          content: indexValue
        }
      ].filter(
        // Remove meta items where content is not set or date is default value
        (m) => !!m.content && '0001-01-01T00:00:00Z' !== m.content
      )
    });
  }
};
</script>
